// extracted by mini-css-extract-plugin
export var container = "_cz-0";
export var infoIcon = "_cz-2";
export var internalLabel = "_cz-3";
export var titleRowCol = "_cz-1";